import { get } from "lodash";
import { Component } from "vue";
import { AdUnitFilter } from "./adUnit";
import { AvailabilityFilterModel } from "./availability";
import Campaign, { CampaignFilters } from "./campaign";
import Site from "./site";

export interface Alert {
  id?: string;
  text: string;
  type: string;
  icon?: string;
  meta?: any;
}

export interface ServerMessage {
  status: string;
  details: string;
  title: string;
}

export interface Select {
  text: string;
  value: any;
}

export interface QueryParams {
  page?: QueryParamsPage;
  filter?: AdUnitFilter | AvailabilityFilterModel;
  search?: string;
  fields?: any;
}

export interface QueryParamsPage {
  number?: number;
  size?: number;
}

export class Meta {
  pagination: MetaPagination;
  sort?: string;
  order?: string;

  constructor(params?: Meta) {
    this.pagination = get(params, "pagination", new MetaPagination());
    this.sort = get(params, "sort", undefined);
    this.order = get(params, "order", undefined);
  }
}

export class MetaPagination {
  current: number;
  size: number;
  next: number | null;
  prev: number | null;
  totalPages: number;
  totalCount: number;

  constructor(params?: MetaPagination) {
    this.current = get(params, "current", 1);
    this.size = get(params, "size", 10);
    this.next = get(params, "next", null);
    this.prev = get(params, "prev", null);
    this.totalPages = get(params, "totalPages", 0);
    this.totalCount = get(params, "totalCount", 0);
  }
}

export class Pagination {
  page: number;
  itemsPerPage: number;
  sortBy: string[];
  sortDesc: string[];
  groupBy: string[];
  groupDesc: string[];
  mustSort: boolean;
  multiSort: boolean;

  constructor(params?: Pagination) {
    this.page = get(params, "page", 1);
    this.itemsPerPage = get(params, "itemsPerPage", 10);
    this.sortBy = get(params, "sortBy", []);
    this.sortDesc = get(params, "sortDesc", []);
    this.groupBy = get(params, "groupBy", []);
    this.groupDesc = get(params, "groupDesc", []);
    this.mustSort = get(params, "mustSort", false);
    this.multiSort = get(params, "multiSort", false);
  }
}

export type Form = Vue & { validate: () => boolean; reset: () => void };

export class Dialog {
  show: boolean;
  title: string;
  text: string;
  cancelButton: string;
  successButton: DialogCallback;
  showCancelButton?: boolean;
  width?: string | number | null;
  component?: Component | null;
  componentProps?: any;

  constructor(params?: Dialog) {
    this.show = get(params, "show", false);
    this.title = get(params, "title", "");
    this.text = get(params, "text", "");
    this.cancelButton = get(params, "cancelButton", "");
    this.successButton = get(params, "successButton", {
      text: "general.accept",
      type: "primary",
      closeDialog: true,
      callback: () => {
        return null;
      },
    });
    this.showCancelButton = get(params, "showCancelButton", true);
    this.width = get(params, "width", null);
    this.component = get(params, "component", null);
    this.componentProps = get(params, "componentProps");
  }
}

export class DialogCallback {
  text: string;
  type: string;
  callback: any;
  closeDialog?: boolean;

  constructor(params?: DialogCallback) {
    this.text = get(params, "text", "general.accept");
    this.type = get(params, "type", "primary");
    this.callback = get(params, "callback", () => {
      return null;
    });
    this.closeDialog = get(params, "closeDialog", true);
  }
}

export interface DashboardTabs {
  id: string;
  label: string;
  icon: string;
  data: Campaign[];
  meta?: Meta;
  columns: string[];
  loading: boolean;
  filter: CampaignFilters;
}

export interface TableHeaders {
  text: string;
  sortable: boolean;
  value: string;
}

export interface TableHeaderFilters {
  id: string;
  value: string;
}

export interface TableHeaderFilterGrouped {
  label: string;
  filter: TableHeaderFilters[];
}
